module.exports = __webpack_public_path__ + "img/img-dingzhi-s5-tuya.ddc7be97.jpg";